import { render } from "./BaseTitle.vue?vue&type=template&id=46125fad&scoped=true&ts=true"
import script from "./BaseTitle.vue?vue&type=script&lang=ts"
export * from "./BaseTitle.vue?vue&type=script&lang=ts"

import "./BaseTitle.vue?vue&type=style&index=0&id=46125fad&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46125fad"]])

export default __exports__